<script setup>
import { parseJwtPayload } from "~/types/permission/Types";
import { useCustomizerStore } from "@/stores/customizer";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { useContactCallStore } from "~/stores/contact/call";
import { useContactFormStore } from "~/stores/contact/form";
import { getBowserName, getOsOfUser } from "@/utils/os";
import { usePermissionStore } from "@/stores/permission/index";

const contactCallStore = useContactCallStore();
const contactFormStore = useContactFormStore()
const permissionStore = usePermissionStore();

import { useRouter } from "vue-router";
var { rolePermission } = permissionStore;

const router = useRouter();

router.afterEach(() => {
  document.getElementById("scroll-container").scrollIntoView();
});

const customizer = useCustomizerStore();

const baseUrl = import.meta.env.VITE_PUSH_BIZ_URL;
const runOnIp = import.meta.env["VITE_RUN_ON_IP"];

const callPopOpState = ref(false);

const FirebaseSubscription = () => {
  const firebaseToken = localStorage.getItem("firebaseToken");
  if (!firebaseToken) {
    const token = localStorage.getItem("token");
    const jwt = parseJwtPayload();
    const firebaseConfig = {
      apiKey: "AIzaSyCnW2U_KD_v0O-bjWvqwhO4qwOI9_K1hSE",
      authDomain: "nava-tel.firebaseapp.com",
      projectId: "nava-tel",
      storageBucket: "nava-tel.appspot.com",
      messagingSenderId: "586769003980",
      appId: "1:586769003980:web:480223c89a8c63f60fd969",
      measurementId: "G-ST1YBBWN9G",
    };
    const Keypair =
      "BMmLgusEC59_8DBWP81tNIvLve7ecP7vbNFnZ2_Bss0cE6Cc3OMI3o0Lmr3Qp6C9UjwZ78FV-RQN0WIUxzwAvV4";
    const app = initializeApp(firebaseConfig);

    const messaging = getMessaging(app);
    const analytics = getAnalytics(app);
    getToken(messaging, { vapidKey: Keypair })
      .then((currentToken) => {
        console.log("then side . . .", currentToken);
        if (currentToken) {
          localStorage.setItem("firebaseToken", currentToken);
          ServerSubscription(jwt.sub, token);
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  } else {
    // const token = localStorage.getItem("token");
    // const jwt = JSON.parse(
    //   Buffer.from(token.split(".")[1], "base64").toString()
    // );
    // ServerSubscription(jwt.sub, token);
  }
};

const ServerSubscription = async (userId, userToken) => {
  const firebaseToken = localStorage.getItem("firebaseToken");
  if (firebaseToken) {
    const platform = window.navigator.platform;
    const deviceMemory = window.navigator.deviceMemory;

    const raw = JSON.stringify({
      user_id: userId,
      push_token: firebaseToken,
      pushkit_token: "",
      push_platform: "8",
      device_id: `${userId}-${getBowserName()}-${platform}-${deviceMemory}/cp_dashboard`,
      device_model: getBowserName(),
      app_name: "Navatel Dashboard Aplication",
      app_ver: "1.0.0",
      os_ver: getOsOfUser(),
      environment: process.env.NODE_ENV,
    });

    await fetch(`${baseUrl}/subscribe`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "application/json",
      },
      body: raw,
    })
      .then((response) => {
        console.log("S U B S C R I B E   O N   F I R E B A S E  . . . ");
        console.log(
          "S U B S C R I B E   O N   N A V A T E L   S E R V I C E S . . . "
        );
      })
      .catch((err) => {
        console.log(
          "S U B S C R I B E   O N   N A V A T E L   S E R V I C E S   H A S   E R R O R . . . ",
          err
        );
      });
  } else {
    FirebaseSubscription();
  }
};

const userId = ref("")
const hasCiPermission = computed(() => rolePermission?.permission.get("root/contacts")?.visible ?? false)
onMounted(() => {
  customizer.selectedMenu = null
  customizer.selectedItem = []
  customizer.inSidebar = false
  customizer.activeChilds = false
  customizer.inActiveChildBody = false
  customizer.parentHovered = ''
  contactFormStore.initializeForms();

  if (runOnIp == "0") {
    const firebaseConfig = {
      apiKey: "AIzaSyCnW2U_KD_v0O-bjWvqwhO4qwOI9_K1hSE",
      authDomain: "nava-tel.firebaseapp.com",
      projectId: "nava-tel",
      storageBucket: "nava-tel.appspot.com",
      messagingSenderId: "586769003980",
      appId: "1:586769003980:web:480223c89a8c63f60fd969",
      measurementId: "G-ST1YBBWN9G",
    };
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    onMessage(messaging, async (payload) => {
      console.log("Payload Content . . .", payload);
      if (payload.data.PhoneNumber) {
        const startWith = payload.data.PhoneNumber.slice(0, 2);
        if (startWith == "00") {
          return;
        } else {
          if (payload.data.PhoneNumber.length < 30) {
            if (callPopOpState.value) {
              callPopOpState.value = false;
            }
            setTimeout(async () => {
              callPopOpState.value = true;
              const response = await contactCallStore.existByPhoneNumber(
                payload.data
              );
            }, 0);
          }
        }
      }
    });
  }
  if(!hasCiPermission.value) return;
  const cookie = useCookie("accessToken");
  localStorage.setItem("token", cookie.value);
  const jwt = parseJwtPayload();
  userId.value = jwt.sub;
  if (runOnIp == "0") {
    FirebaseSubscription();
    ServerSubscription(jwt.sub, cookie.value);
  }
});
</script>

<template>
  <!-----RTL LAYOUT------->
  <v-locale-provider v-if="customizer.setRTLLayout" rtl>
    <base-modal-alert />
    <BaseToast location="left" />
    <v-app
      :theme="customizer.actTheme"
      :class="[
        customizer.actTheme,
        customizer.mini_sidebar ? 'mini-sidebar' : '',
        customizer.setHorizontalLayout ? 'horizontalLayout' : 'verticalLayout',
        customizer.setBorderCard ? 'cardBordered' : '',
      ]"
    >
      <!---Customizer location left side--->
      <v-navigation-drawer
        app
        temporary
        elevation="10"
        location="left"
        v-model="customizer.Customizer_drawer"
        width="320"
        class="left-customizer"
      >
        <LcFullCustomizer />
      </v-navigation-drawer>
      <LcFullVerticalSidebar v-if="!customizer.setHorizontalLayout && !$vuetify.display.mobile" />
      <LcFullVerticalHeader v-if="!customizer.setHorizontalLayout" />
      <LcFullMobileSidebar v-if="customizer.mobileSidebar" />
      <!-- <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
      </div> -->
      <!-- <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
        <LcFullHorizontalHeader v-if="customizer.setHorizontalLayout" />
      </div>
      <LcFullHorizontalSidebar v-if="customizer.setHorizontalLayout" /> -->

      <v-main>
        <LcFullVerticalSidebarChildren v-if="customizer.activeChilds" />
        <perfect-scrollbar style="height: calc(100vh - 60px)">
          <div id="scroll-container" class="rtl-lyt hr-layout">
          <v-container
            fluid
            class="page-wrapper bg-background rounded-xl mt-5"
            :class="{'mt-3': $vuetify.display.mobile}"
          >
            <div class="w-100">
              <NuxtPage />
              <CallPopOp
                :state="callPopOpState"
                @close="callPopOpState = false"
              />
            </div>
          </v-container>
          </div>
        </perfect-scrollbar>
      </v-main>
    </v-app>
  </v-locale-provider>

  <!-----LTR LAYOUT------->
  <v-locale-provider v-else>
    <base-modal-alert />
    <BaseToast location="left" />
    <v-app
      :theme="customizer.actTheme"
      :class="[
        customizer.actTheme,
        customizer.mini_sidebar ? 'mini-sidebar' : '',
        customizer.setHorizontalLayout ? 'horizontalLayout' : 'verticalLayout',
        customizer.setBorderCard ? 'cardBordered' : '',
      ]"
    >
      <!---Customizer location right side--->
      <v-navigation-drawer
        app
        temporary
        elevation="10"
        location="right"
        v-model="customizer.Customizer_drawer"
        width="320"
      >
        <LcFullCustomizer />
      </v-navigation-drawer>
      <LcFullVerticalSidebar v-if="!customizer.setHorizontalLayout" />
      <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
        <LcFullVerticalHeader v-if="!customizer.setHorizontalLayout" />
      </div>
      <div :class="customizer.boxed ? 'maxWidth' : 'full-header'">
        <LcFullHorizontalHeader v-if="customizer.setHorizontalLayout" />
      </div>
      <LcFullHorizontalSidebar v-if="customizer.setHorizontalLayout" />
      <v-main>
        <perfect-scrollbar style="height: calc(100vh - 96px)">
          <div id="scroll-container" class="hr-layout">
          <v-container
            fluid
            class="page-wrapper bg-background px-sm-5 px-4 pt-8 pb-0 rounded-xl"
          >
            <div class="">
              <div :class="customizer.boxed ? 'maxWidth' : ''">
                <NuxtPage />
                <v-btn
                  class="customizer-btn"
                  size="large"
                  icon
                  variant="flat"
                  color="primary"
                  @click.stop="
                    customizer.SET_CUSTOMIZER_DRAWER(
                      !customizer.Customizer_drawer
                    )
                  "
                >
                  <SettingsIcon />
                </v-btn>
              </div>
            </div>
          </v-container>
          </div>
        </perfect-scrollbar>
      </v-main>
    </v-app>
  </v-locale-provider>
</template>